// stylelint-disable selector-max-compound-selectors
ux-iws-stateful-table .ux-mobile-table ux-accordion {
    position: relative;

    .ux-w-status__text {
        display: inline;
    }

    // mobile styles for textAndDate table header
    .ux-iws-table-header--text-and-date {
        left: 75px;
        position: absolute;
    }

    .ux-iws-table-header__date {
        background: var(--ux-button-selected-bg-color);
        border-radius: 5px;
        color: var(--ux-button-selected-text-color);
        margin-left: 10px;
        padding: 5px 10px;
        text-align: center;

        &__month {
            font-size: 1.5em;
            font-weight: bold;
            line-height: 1em;
        }
    }
}

.ux-iws-sateful-table__header--long-label {
    display: inline-block;
    max-width: 220px;
    white-space: initial;
}
